import { Fragment } from 'react';
import { Outlet } from 'react-router-dom';

import classNames from 'classnames';

import { LazyLoader } from '@hsp/react-component-library';

import { Idle } from 'components/idle';
import { SignalR } from 'components/signalr';

import { Footer, Header, Sidebar } from './components';
import { useVerticalLayoutConfiguration } from './hooks';

const Layout = () => {
  const { ref, open } = useVerticalLayoutConfiguration();

  return (
    <Fragment>
      <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
          </div>
        </div>
      </div>
      <Header />
      <div className="layout-wrapper">
        <Sidebar />
        <div className={classNames('main-content', { open })}>
          <div
            className="position-relative h-100"
            ref={ref}>
            <Idle />
            <LazyLoader target={ref}>
              <SignalR uri={process.env.REACT_APP_AZURE_SIGNAL_R}>
                <Outlet />
              </SignalR>
            </LazyLoader>
          </div>
        </div>
      </div>
      <Footer />
    </Fragment>
  );
};

export default Layout;
